/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 4/20/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */
import http, { formConfig } from "@/utils/http";
const url = action => `/admin/${action[0]}`;

export default class ADMIN {
  static LOGIN_URL = url`login`;
  static LOGOUT_URL = url`logout`;
  static USER(params) {
    return http.get(url`user`, { params });
  }
  static MENU(params) {
    return http.get(url`menu`, { params });
  }
  static IP_LIMIT(data) {
    return http.post(url`iplimit`, data, formConfig);
  }
  static STOP_APPLICATION(data) {
    return http.post(url`stopapplication`, data, formConfig);
  }
}
